package com.happyukrainian.revision.kweb.pages

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.happyukrainian.revision.kweb.canShare
import com.happyukrainian.revision.kweb.components.PageContainer
import com.happyukrainian.revision.kweb.config.ButtonStyle
import com.happyukrainian.revision.kweb.config.HUColors
import com.happyukrainian.revision.kweb.pages.routes.FlashCardsRoute
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.background
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import flashcards.FlashCard
import kotlinx.browser.window
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.vh
import org.jetbrains.compose.web.css.vw
import repositories.HttpClientMaterialRepository
import repositories.HttpClientTopicRepository

@Page("subject/{subject}/topic/{topic}/flashcards")
@Composable
fun FlashcardPage() {
    val ctx: PageContext = rememberPageContext()
    val subject = ctx.route.params.getValue("subject")
    val topic = ctx.route.params.getValue("topic")
    var flashcards by remember { mutableStateOf(emptyList<FlashCard>()) }
    var topicName by remember { mutableStateOf("") }
    val shareScope = rememberCoroutineScope()

    LaunchedEffect(subject, topic) {
        HttpClientTopicRepository().fetchTopics(subject).onSuccess {
            topicName = it.topics.first { it.key == topic }.name
        }
        HttpClientMaterialRepository().fetchMaterials(subject, topic).onSuccess {
            flashcards = it.flashCards
        }
    }

    Column(modifier = Modifier.fillMaxWidth().minHeight(100.vh).background(HUColors.background)) {
        Row(
            modifier = Modifier.width(100.percent).padding(0.5.vw),
            verticalAlignment = Alignment.CenterVertically,
        ) {
            Button(
                onClick = {
                    ctx.router.navigateTo("../../topics")
                },
                modifier = ButtonStyle.toModifier().margin(right = 0.5.vw),
            ) {
                SpanText("Topics")
            }
            Spacer()
            if (window.navigator.canShare) {
//                Button(
//                    modifier = ButtonStyle.toModifier(),
//                    onClick = {
//                        window.navigator.share?.let { shareFunction ->
//                            shareScope.launch {
//                                shareFunction(
//                                    object : ShareData {
//                                        override var title: String? = "HappyUkrainian Revision - $topicName"
//                                        override var text: String? = "I'm studying $topicName using the HappyUkrainian revision website."
//                                        override var url: String? = document.location!!.href
//                                    },
//                                ).await()
//                            }
//                        }
//                    },
//                ) {
//                    SpanText(topicName)
//                }
            }
            Spacer()
            Button(
                modifier = ButtonStyle.toModifier().margin(right = 0.5.vw),
                onClick = {
                    ctx.router.navigateTo("/")
                },
            ) {
                SpanText(text = "Home")
            }
        }
        Box(modifier = Modifier.fillMaxWidth().weight(1f).overflow(Overflow.Hidden), contentAlignment = Alignment.Center) {
            PageContainer {
                FlashCardsRoute(
                    flashcards,
                    it,
                )
            }
        }
    }
}
